export default __webpack_public_path__ + "static/media/design.67ddfc9b.jpg";